import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Image, 
  // Media
 } from 'react-bootstrap';
import styles from './ContactView.module.scss';
import DOMPurify from 'dompurify';

import { localizedStrings } from 'src/localization';

class ContactView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
  }


  render() {
    var indexLetter = "#";

    if (this.props.contact && this.props.contact.firstName) {
      indexLetter = this.props.contact.firstName.charAt(0).toUpperCase();
      if (!indexLetter.match(/[a-z]/i)) {
        indexLetter = '#';
      }
    }

    return (
      <div onClick={()=>this.props.showContactsView(this.props.contact)} className={cx(styles.contact, 'contact', this.props.className)} data-index={indexLetter}>
        <div key={this.props.contact.id} className={styles.contactContainer}>
          <div className={styles.left}>
            <div className={styles.iconContainer}>
              {!this.props.contact.icon &&
                <div className={styles.contactAvatar}> 
                <i className="paperflite-user-settings" />
                </div>}
              {this.props.contact.icon &&
                <Image className={styles.contactIcon} src={this.props.contact.icon.thumbnail} roundedCircle />}
            </div>
          </div>
          <div className={styles.body}>
              <div className={styles.contactName}>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.contact.name)}}></div>
              </div>
              <div className={styles.contactTitle}>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.contact.email) || this.localizedCommons.no_details }}></div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactView;